export default __webpack_public_path__ + "static/media/alertes-4.bfa9ee4f.png";